import { cva } from "class-variance-authority";

// AIDEV-NOTE: Soft taxonomy variants (forest/terra/cream/burgundy/exile) classify
// content — part type, session count, archetype. Tinted bg, no border.
// `warning` is the amber/draft variant for status indicators (e.g. "draft" badge).
// Don't mix with status chips (see StatusChip) — those signal live state.
export const badgeVariants = cva(
    "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
    {
        variants: {
            variant: {
                default:
                    "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
                secondary:
                    "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
                destructive:
                    "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
                outline: "text-foreground",
                forest: "border-transparent bg-brand-forest-100 text-brand-forest-800",
                terra: "border-transparent bg-brand-terra-100 text-brand-terra-700",
                cream: "border-transparent bg-brand-cream-300 text-brand-forest-800",
                burgundy: "border-transparent bg-[#FBE3E3] text-[#691819]",
                exile: "border-transparent bg-[#EDE1FA] text-[#4A3776]",
                warning: "border-transparent bg-[#FCF3D8] text-[#92400E]",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    },
);
